import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Container } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from './img/logo.png'

const LoginForm = ({ api, location, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('pt-BR');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'fibra';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = "Houve um erro. Tente novamente";

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-fibra-container" ref={nodeRef}>
        <img src={logo} alt="logo" className="logo-fibra rounded mx-auto d-block" />
        <h3>Acesse com login pronto fibra</h3>
        <Form onSubmit={(event) => onSubmit(event)}>
          <Container fluid={true} className="fibra-form-container">
            <Row className="fibra-form-body">
              <Col sm="12" xs="12" md="12">
                <Input
                  className="user-input-fibra"
                  disabled={onLogin}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="username"
                  placeHolder="cpf ou e-mail"
                  onChange={e => setUsername(e.target.value)}
                />
              </Col>
            </Row>
            <Row className="fibra-form-body">
              <Col sm="12" xs="12" md="12">
                <Input
                  className="pass-input-fibra"
                  required={true}
                  disabled={onLogin}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  placeHolder="senha"
                  onChange={e => setPassword(e.target.value)}
                />
              </Col>
            </Row>
            <Row className="fibra-form-footer">
              <Col sm="12" xs="12" md="12" style={{ textAlign: 'center', padding: '0' }}>
                {!onLogin ? (
                  <div>
                    <button
                      block={!parameters.failureRedirect}
                      tabIndex={1}
                      type="submit"
                      id="submmit"
                      className="enter-fibra"
                      disabled={!props.turnstileSuccess}
                    >
                      {translate("ButtonEnter")}
                    </button>
                  </div>
                ) : (
                  <Progress animated color="danger" value={100} />
                )}
              </Col>
              <div className="messages-container fibra-error">
                <Alert
                  color="danger"
                  id="error-message"
                  isOpen={error.open}
                  toggle={() => setError({ open: false })}
                >
                  {error.message}
                </Alert>
              </div>

            </Row>
          </Container>
        </Form>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { style: { marginBottom: '2rem' } });
